"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _authenticationHelpers = require("./authenticationHelpers");

/* eslint-disable no-undef */

/* eslint-disable no-restricted-globals */
var _default = ({
  dispatch,
  getters
}) => ({
  // eslint-disable-line
  configure({
    oidcClientId,
    authCallbackUrl
  }) {
    dispatch('authentication/setOidcClientId', oidcClientId);
    dispatch('authentication/setAuthCallbackUrl', authCallbackUrl);
  },

  async handleAuthentication(guardCallback) {
    const token = getters['authentication/token'];

    if (token) {
      await guardCallback();
      return;
    }

    location.replace('/');
  },

  async exchangeCodeForToken(code, loginContext, clientId, redirectUri, audience) {
    const payload = (0, _authenticationHelpers.getExchangeCodeForTokenPayload)(code, loginContext, clientId, redirectUri, audience);
    await dispatch('authentication/exchangeCodeForToken', payload);
  },

  async logout(idToken, postLogoutUrl, logoutUrl) {
    const logoutRedirectionUrl = logoutUrl || process.env.VUE_APP_LOGOUT_REDIRECTION_URL;
    await dispatch('authentication/clearTokens');
    location.replace(`${logoutRedirectionUrl}?id_token_hint=${idToken}&post_logout_redirect_uri=${postLogoutUrl}`);
  },

  getBearer() {
    return `Bearer ${getters['authentication/token']}`;
  },

  async getLoginUrl({
    to,
    clientId,
    redirectUri,
    locale,
    audience,
    acrValues,
    requestUrl
  }) {
    const verifier = (0, _authenticationHelpers.getCodeVerifier)();
    const codeChallenge = (0, _authenticationHelpers.getCodeChallenge)(verifier);
    const state = (0, _authenticationHelpers.getState)();
    await dispatch('authentication/setLoginContext', {
      verifier,
      codeChallenge,
      state,
      to
    });
    return (0, _authenticationHelpers.getLoginRedirectionUrl)(state, codeChallenge, clientId, redirectUri, locale, audience, acrValues, requestUrl);
  },

  async executeRefreshToken(from = '/book') {
    await dispatch('authentication/refreshToken', {
      redirectTo: from
    });
  },

  async executeSilentRefreshToken(duration = 600000) {
    if ((parseInt(getters['authentication/tokenExpiredAt'], 10) || 0) < (0, _authenticationHelpers.getTokenExpirationFromDuration)(duration)) {
      await dispatch('authentication/refreshToken', {}, {
        root: true
      });
    }
  }

});

exports.default = _default;